import { render } from "./RealTaskTypes.vue?vue&type=template&id=0b14c928&scoped=true"
import script from "./RealTaskTypes.vue?vue&type=script&lang=js"
export * from "./RealTaskTypes.vue?vue&type=script&lang=js"

import "./RealTaskTypes.vue?vue&type=style&index=0&id=0b14c928&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0b14c928"]])

export default __exports__